import { NgModule } from '@angular/core';
// eslint-disable-next-line no-restricted-imports
import { MatDialogModule } from '@angular/material/dialog';

import { TypedDialogService } from './typed-dialog.service';

import { TypedDialogDirective } from './typed-dialog.directive';

@NgModule({
  declarations: [TypedDialogDirective],
  exports: [MatDialogModule, TypedDialogDirective],
  imports: [MatDialogModule],
  providers: [TypedDialogService],
})
export class TypedDialogModule {}
